import React from 'react';

import { SvgIcon, SvgIconProps } from '@mui/material';

const Variant15: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12Z" />
    </SvgIcon>
  );
};

export default Variant15;
